export default __webpack_public_path__ + "img/phone-call.de92be7a386cc5a5789921accb7d2366.png";